import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
const Phuluc6table = React.memo(function Phuluc6table(props) {
  const classes = useStyles();
  const { data, nam } = props;
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th} style={{ width: "35vw" }}>
            Chỉ tiêu
          </th>
          <th className={classes.tablebc_th}>Sơ bộ năm {nam}</th>
          <th className={classes.tablebc_th}>So với cùng kỳ (%)</th>
        </tr>
        <tr>
          <th className={classes.tablebc_th}>A</th>
          <th className={classes.tablebc_th}>1</th>
          <th className={classes.tablebc_th}>2</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        {data.map((row, i) => {
          return (
            <tr key={i}>
              <td className={classes.tablesotan_td}>{row["chitieu"]}</td>
              <td className={classes.tablesotan_td}>{row["thuchien_nam"]}</td>
              <td className={classes.tablesotan_td}>{row["tyle_socungky"]}</td>
            </tr>
          );
        })}
        <tr>
          <td className={classes.tablesotan_td}>
            C. TỔNG SẢN LƯỢNG HÀNG HÓA THÔNG QUA CẢNG - Nghìn TTQ
          </td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div>
      <table className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

Phuluc6table.propTypes = {
  data: PropTypes.array,
  nam: PropTypes.string,
};
export default Phuluc6table;
